module.exports = __webpack_public_path__ + "img/preview.57960db9.png";